// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQueryWithOffset } from '@hooks/other/useQueryWithOffset';
import { UseQueryResult } from '@tanstack/react-query';
import { TransferRule } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Rule/Transfer';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';

const useTransferRules: (
  operator: string,
  registrar: string,
) => UseQueryResult<TemplateContract<TransferRule>[], string> = (operator, registrar) => {
  const ledgerApi = useLedgerApiClient();

  return useQueryWithOffset({
    queryKey: ['queryTransferRules', operator, registrar],
    queryFn: async (_, offset) => {
      return ledgerApi.queryTransferRules(offset, operator, registrar);
    },
  });
};

export default useTransferRules;
